// menuType (integer): 菜单类型:
export const MENU_TYPE_ENUM = {
  DIRECTORY: {
    value: 1,
    desc: '目录'
  },
  MENU: {
    value: 2,
    desc: '菜单'
  },
  FUNCTION: {
    value: 3,
    desc: '功能点'
  }
};

export default {
  MENU_TYPE_ENUM
};
